<template>
    <div class="SubmitFrom">
        <div class="float flex_col ">
            <div class="li flex_col click" @click="dialogFormVisible = true">
                <img src="../../assets/float1.png"/>
                <p>提交需求</p>
            </div>
        </div>
        <div class="join">
            <el-dialog
                    :visible.sync="dialogFormVisible"
                    width="40%"
                    :before-close="handleClose"
            >
                <!--        表单开始-->
                <div class="information_From">
                    <div class="information_From_title">提交您的需求</div>
                    <div class="information_FromData">
                        <el-form class="el_form" :rules="rules" ref="form" :model="form" label-width="80px">
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="姓名" prop="applicat">
                                        <el-input v-model="form.applicat" placeholder="姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="邮箱" prop="email">
                                        <el-input v-model="form.email" placeholder="邮箱格式：xxx@xx.com"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="手机号" prop="phone">
                                        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="公司地址" prop="address">
                                        <el-input v-model="form.address" placeholder="请输入公司地址"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="22">
                                    <el-form-item label="留言内容">
                                        <el-input type="textarea"  v-model="form.content" placeholder="请输入留言内容"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" :offset="6">
                                    <el-form-item>
                                        <el-button type="primary" @click="submitForm('form')">发送您的需求</el-button>
                                    </el-form-item>
                                </el-col>
<!--                                <el-col :span="8">-->
<!--                                    <div class="information_From_tips"> 或者发送业务咨询到邮箱:<p> 76989366@qq.com</p></div>-->
<!--                                </el-col>-->
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <!--        表单 结束-->
            </el-dialog>
        </div>
    </div>
</template>
<script>
    // import {saveServiceApi} from "/src/api/index.js";

    export default {
        data() {
            var checkEmail = (rule, value, callback) => {
                const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
                if (regEmail.test(value)) {
                    return callback()
                }
                callback("请输入合法邮箱")
            };
            var checkMobile = (rule, value, callback) => {
                const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
                if (regMobile.test(value)) {
                    return callback()
                }
                callback("请输入合法手机号")
            };
            return {
                // dialogTableVisible: false,
                dialogFormVisible: false,
                form: {
                    applicat: '',
                    email: '',
                    phone: '',
                    delivery: false,
                    content: ''
                },
                formLabelWidth: '120px',
                Timer: [],
                rules: {
                    applicat: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '请输入邮箱', trigger: 'blur'},
                        {validator: checkEmail, trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入手机号或电话号码', trigger: 'blur'},
                        {validator: checkMobile, trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请填写留言内容', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
            this.getTimer()
        },

        methods: {
            // 定时弹出表单
            getTimer() {
                this.Timer = setTimeout(() => {
                    clearTimeout(this.Timer)
                    this.dialogFormVisible = true
                }, 60000)
            },

            handleClose(done) {
                clearTimeout(this.Timer)
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                done()
            },
            // 提交表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert('submit!');



                        // saveServiceApi(this.form).then((res) => {
                        //     console.log(res)
                        //     this.newsList = res.data.list
                        //
                        // });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }

        }
    }
</script>
<style scoped>

    .float {
        height: 150px;
        width: 48px;
        position: fixed;
        z-index: 2000;
        top: 200px;
        right: 0px;
        font-size: 12px;
        padding: 0px 10px;
        box-sizing: border-box;
        justify-content: space-around;
        border-bottom: 1px solid #ededed;
        border-top: 1px solid #ededed;
        border-left: 1px solid #ededed;
        background: white;
    }

    .float .li {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #ededed;
        padding: 10px 0px;
        box-sizing: border-box;
    }

    .float .li:last-child {
        border-bottom: none;
    }

    .join >>> .el-dialog__header {
        padding: 0;
    }

    .join >>> .el-dialog__body {
        padding: 0;
    }

    .join .btn {
        width: 200px;
        height: 36px;
        background-color: rgba(9, 55, 99, 0.23);
        margin-top: 30px;
        text-align: center;
        line-height: 36px;
        border-radius: 18px;
        color: white;
    }

    .information_From {
        /*padding-top: 154px;*/
        /*width: 500px;*/
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .information_From_title {
        font-size: 24px;
        padding: 20px 0;
        color: #EC59A1;
    }

    .information_From_tips {
        display: flex;
        justify-content: center;
        align-items: center;
        /*width: 410px;*/
        flex-wrap: wrap;
        padding-top: 10px;
        color: #8C9196;
        width: 200px;
        padding-left: 70px;
    }

    .information_From_tips p {
        color: #EC59A1;
    }

    .el_form {
        padding-left: 5%;
    }

    .click {
        cursor: pointer;
    }

    .information_FromData >>> .el-textarea__inner
    {
        width: 100%!important;
        height: 100px!important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }

</style>



// WEBPACK FOOTER //
// src/views/components/SubmitFrom.vue